import { userRoutes } from './user-routes'; // 自由用户路由表
import {
    rolePermErrRoute,
    permErrRoute,
    notFoundRoute,
    matchAllRoute,
    permissionRoutes,
    staticRoutes,
} from './static-routes';

// 所有用户路由表
import { authorRoutes } from './author-routes';

// 企业用户公共路由表,绩效咨询公司用户,预算单位用户,财政局用户公共路由表
import { enterpriseCommonRoutes } from './enterprise-common-route';
// 绩效咨询公司用户路由表
import { consultantRoutes } from './consultant-routes';
// 预算单位用户路由表
import { budgetRoutes } from './budget-routes';
// 财政局用户路由表
import { financeRoutes } from './finance-routes';

export { staticRoutes, rolePermErrRoute, permErrRoute, notFoundRoute, matchAllRoute };

// 非企业用户路由表
export const freeUserRoutes = [ ...staticRoutes, ...authorRoutes, ...userRoutes, ...permissionRoutes, notFoundRoute, matchAllRoute ];

// 第三方及绩效咨询公司用户路由表
export const consultantUserRoutes = [ ...staticRoutes, ...authorRoutes, ...enterpriseCommonRoutes, ...consultantRoutes, ...permissionRoutes, notFoundRoute, matchAllRoute ];

// 预算单位用户路由表
export const budgetUserRoutes = [ ...staticRoutes, ...authorRoutes, ...enterpriseCommonRoutes, ...budgetRoutes, ...permissionRoutes, notFoundRoute, matchAllRoute ];

// 财政局用户路由表
export const financeUserRoutes = [ ...staticRoutes, ...authorRoutes, ...enterpriseCommonRoutes, ...budgetRoutes, ...financeRoutes, ...permissionRoutes, notFoundRoute, matchAllRoute ];

